import * as Yup from 'yup';
export const profileUpdateSchema = Yup.object().shape({
    companyName: Yup.string()
      .min(2, 'Company name must be at least 2 characters')
      .required('Company name is required'),
    
    companyPhoneNumber: Yup.string()
      .required('Phone number is required')
      .test('is-phone', 'Phone must be a valid number with country code', 
        value => {
            return /^\+\d{1,3}\d{10}$/.test(value);
        }),
    
    contactName: Yup.string()
      .min(2, 'Contact name must be at least 2 characters')
      .required('Contact name is required'),
    
    contactPhoneNumber: Yup.string()
      .required('Phone number is required')
      .test('is-phone', 'Phone must be a valid number with country code', 
        value => {
            return /^\+\d{1,3}\d{10}$/.test(value);
        }),
  
    bankAccountName: Yup.string()
      .min(2, 'Account name must be at least 2 characters')
      .required('Account name is required'),
  
    bankAccountNumber: Yup.string()
      .required('Account number is required')
      .matches(/^\d+$/, 'Account number must contain only digits')
      .min(8, 'Account number must be at least 8 digits')
  });